<div
  [ngbTooltip]="getTooltip() | translate: { maxExport: maxExport }"
  [closeDelay]="500"
>
  <button
    class="tick-btn tick-btn-lg tick-btn-default"
    [disabled]="!totalCount() || totalCount() > maxExport"
    [attr.aria-disabled]="!totalCount() || totalCount() > maxExport"
    data-cy="export-orders-list-btn"
    mat-button
    (click)="exportOrders()"
  >
    {{ 'orders.export.export' | translate }}
  </button>
</div>
